import React from "react";
import Spacing from "../Spacing";
import SectionHeadingStyle3 from "../SectionHeading/SectionHeadingStyle3";
import AboutStyle4 from "../About/AboutStyle4";
import FunFact from "../FunFact";
import AboutStyle5 from "../About/AboutStyle5";
import IconBoxStyle6 from "../IconBox/IconBoxStyle6";
import SectionHeadingStyle5 from "../SectionHeading/SectionHeadingStyle5";
import SectionHeading from "../SectionHeading";
import TeamSlider from "../Slider/TeamSlider";
import Marquee from "../Marquee";
import Brands from "../Brands";
import { pageTitle } from "../../helpers/PageTitle";
const funfactData = [
  { title: "Happy Customers", number: "22k" },
  { title: "Work’s Completed", number: "15k" },
  { title: "Skilled Team Members", number: "121" },
  { title: "Most Valuable Awards", number: "15" },
];
const teamData = [
  {
    memberImg: "/images/studio-agency/team_1.jpeg",
    memberName: "James Berline",
    memberDesignation: "React Developer",
    href: "/team/team-details",
  },
  {
    memberImg: "/images/studio-agency/team_2.jpeg",
    memberName: "Bella Zubena",
    memberDesignation: "Graphic Designer",
    href: "/team/team-details",
  },
  {
    memberImg: "/images/studio-agency/team_3.jpeg",
    memberName: "Kemnei Alekzend",
    memberDesignation: "Digital Marketer",
    href: "/team/team-details",
  },
  {
    memberImg: "/images/studio-agency/team_4.jpeg",
    memberName: "Juliya Jesmine",
    memberDesignation: "UX Researcher",
    href: "/team/team-details",
  },
  {
    memberImg: "/images/studio-agency/team_1.jpeg",
    memberName: "James Berline",
    memberDesignation: "React Developer",
    href: "/team/team-details",
  },
  {
    memberImg: "/images/studio-agency/team_2.jpeg",
    memberName: "Bella Zubena",
    memberDesignation: "Graphic Designer",
    href: "/team/team-details",
  },
  {
    memberImg: "/images/studio-agency/team_3.jpeg",
    memberName: "Kemnei Alekzend",
    memberDesignation: "Digital Marketer",
    href: "/team/team-details",
  },
  {
    memberImg: "/images/studio-agency/team_4.jpeg",
    memberName: "Juliya Jesmine",
    memberDesignation: "UX Researcher",
    href: "/team/team-details",
  },
];
const brandList = [
  {
    logoSrc: "/images/marketing-agency/brand_1.svg",
    logoAlt: "Brand",
  },
  {
    logoSrc: "/images/marketing-agency/brand_2.svg",
    logoAlt: "Brand",
  },
  {
    logoSrc: "/images/marketing-agency/brand_3.svg",
    logoAlt: "Brand",
  },
  {
    logoSrc: "/images/marketing-agency/brand_4.svg",
    logoAlt: "Brand",
  },
];
const brandListDark = [
  {
    logoSrc: "/images/marketing-agency/brand_1_dark.svg",
    logoAlt: "Brand",
  },
  {
    logoSrc: "/images/marketing-agency/brand_2_dark.svg",
    logoAlt: "Brand",
  },
  {
    logoSrc: "/images/marketing-agency/brand_3_dark.svg",
    logoAlt: "Brand",
  },
  {
    logoSrc: "/images/marketing-agency/brand_4_dark.svg",
    logoAlt: "Brand",
  },
];

export default function AboutPage({ darkMode }) {
  pageTitle("About");
  return (
    <>
    <style>
      {`
      .cs_about.cs_style_1 .cs_about_thumb {
    overflow: hidden;
    position: relative;
    height: 530px;
    width: 50vw;
    /* margin-right: 61px !important; */
    margin-left: -50px;
    /* margin-left: calc(-50vw + 100%); */
    border-radius: 0 5px 5px 0;
}
      .cs_section_heading.cs_style_1.cs_type_3 {
    position: relative;
    align-items: end;
    text-align: left !important;
}
    .bg-sz-contain{
    background-size: contain!important;
    border-radius: 20px;
    }
    
    .cs_about.cs_style_1 .cs_section_heading p {
      text-align: justify !important;
    }
    
      @media (max-width: 768px) {
        .cs_about.cs_style_1 .cs_about_thumb {
          height: 300px;
          width: 100%;
          margin-left: 0;
          border-radius: 5px;
        }
      }

      `}
    </style>
      <Spacing lg="70" md="70" className="cs_section_heading"/>
      <Spacing lg="140" md="80" className="cs_section_heading" />
      <SectionHeadingStyle3
      className="cs_section_heading"
        title="Supporting Players, Creating Champions"
        subTitle="About Us"
        variant="text-center"
        shape="shape_1"
      />
      <Spacing lg="75" md="60" />
      <AboutStyle4 
  thumbnailSrc="/images/creative-agency/aboutignite.png" 
  miniTitle="Ignite Sports Pavilion – Strength in our past, Fire in our future"
  title="Company Info"
  subTitle={`Ignite Sports Pavilion is Karachi's premier destination for modern sports enthusiasts, located on a prime 46,000 sq.ft facility at Clifton, Karachi.

Ignite Sports Pavilion is more than just a sports facility - it's a testament to our legacy of excellence. Born from the visionary minds behind Faizan Group of Companies, we bring decades of experience in creating spaces that inspire and empower.

From the unyielding strength of Faizan Ste~el, to the visionary structures by Faizan Builders & Developers, every stride we've taken has carried purpose. And now, that momentum gallops forward into a new arena — Ignite Sports Pavilion.
\n\n
Ignite is not just a sports facility; it's the pulse of a new generation. Built with the same steel that symbolizes our foundations, it brings together performance, passion, and play — a place where athletes rise, families connect, and champions are made.
\n\n
OWNED & MANAGED BY Faizan Group of Companies x Ignite.`}
  btnUrl="/service"
/>

      <Spacing lg="125" md="70" />
      <AboutStyle5
        variant="cs_type_1"
        thumbnailSrc="/images/creative-agency/padelcourt1.jpeg"
        miniTitle="What We Do"
        title="A Premier Destination for Sports"
        subTitle="At Ignite, we provide top-tier facilities and expert training programs for Padel, Futsal, and Multi Purpose. Whether you're an aspiring athlete, a fitness enthusiast, or just looking to enjoy a game with friends, our club offers the perfect environment to train, play, and compete."
        progressBarList={[
          { title: " Padel Bookings ", percentage: "90" },
          { title: "Futsal Bookings ", percentage: "80" },
          { title: "Multi Purpose Court Bookings", percentage: "75" },
        ]}
        salesTitle="Player Engagement Growth"
        groth="75"
      />
      <Spacing lg="150" md="80" />
      <section className="cs_primary_bg">
        <Spacing lg="140" md="70" />
        <div className="container">
          <SectionHeadingStyle5 title="How we work" />
          <Spacing lg="85" md="45" />
          <div className="cs_working_process_wrap cs_center">
            <div className="cs_working_process">
              <div className="cs_working_process_col">
                <IconBoxStyle6
                  bgSrc="/images/others/process_1.png"
                  iconSrc="/images/icons/search.svg"
                  title="Explore Courts"
                  subTitle="Find top-quality Padel, Futsal, and Multi Purpose facilities designed for all skill levels. Whether you're training or playing for fun, our courts are ready for action."
                />
              </div>
              <div className="cs_working_process_col">
                <IconBoxStyle6
                  bgSrc="/images/others/process_2.png"
                  iconSrc="/images/icons/idea.svg"
                  title="Book Your Game"
                  subTitle="Reserve your court effortlessly with our easy booking system. Pick your sport, choose a time, and get set to play—quick and hassle-free."
                />
              </div>
              <div className="cs_working_process_col">
                <IconBoxStyle6
                  bgSrc="/images/others/process_3.png"
                  iconSrc="/images/icons/gear.svg"
                  title=" Enjoy the Experience"
                  subTitle="Step onto the field and train, compete, or have fun in a lively sports community. Every game here is about skill, passion, and unforgettable moments."
                />
              </div>
            </div>
          </div>
        </div>
        <Spacing lg="150" md="80" />
      </section>
      {/* <section className="cs_p76_full_width">
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading
            title="Meet our experts team behind <br />the zivan agency"
            subTitle="Our Team"
          />
          <Spacing lg="85" md="45" />
        </div>
        <TeamSlider data={teamData} />
      </section> */}
      {/* <Spacing lg="135" md="70" />
      <Marquee text="Providing world-class courts for Padel, Futsal, and Multi Purpose" />
      <Spacing lg="20" md="50" /> */}
      {/* <div className="container">
        <Brands data={darkMode ? brandListDark : brandList} />
      </div> */}
      <Spacing lg="120" md="80" />
    </>
  );
}
